import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_TOGGLE_MENU} from '../../constants';

export function Menu({isStatic}) {
  const dispatch = useDispatch();
  const isActive = useSelector(state => state.common.menu);
  const user = useSelector(state => state.user.profile);

  useEffect(() => {
    return () => dispatch({type: UPDATE_TOGGLE_MENU, menu: false})
  }, [dispatch]);

  return <aside className={"nav" + (isStatic ? " nav--static" : (isActive ? " nav--active" : ""))}>
    <ul className="nav__list">
      {user && user.modules && user.modules['Chat'] && <li className="nav__item">
        <Link to={'/'} className="nav__link nav__link--chat">Чат</Link>
      </li>}
      {user && user.modules && user.modules['Users'] && <li className="nav__item">
        <Link to={'/users'} className="nav__link nav__link--staff">Сотрудники</Link>
      </li>}
      {user && user.modules && user.modules['Clients'] && <li className="nav__item">
        <Link to={'/clients'} className="nav__link nav__link--users">Пользователи</Link>
      </li>}
      {user && user.modules && (user.modules['GetcourseData'] || user.modules['GetcourseDataItem']) && <li className="nav__item">
        <Link to={'/getcourse_data'} className="nav__link nav__link--users">Пользователи getcourse</Link>
      </li>}
      {user && user.modules && user.modules['Mailing'] && <li className="nav__item">
        <Link to={'/mailings'} className="nav__link nav__link--mailings">Рассылки</Link>
      </li>}
      {/*<li className="nav__item">
        <Link to={'/reports'} className="nav__link nav__link--reports">Отчеты</Link>
      </li>*/}

      {user && user.modules && user.modules['ShiftControl'] && <li className="nav__item">
        <Link to={'/shift_control'} className="nav__link nav__link--reports">Контроль смен</Link>
      </li>}

      {user && user.modules && user.modules['ResponseTime'] && <li className="nav__item">
        <Link to={'/response_time'} className="nav__link nav__link--reports">Время ответов</Link>
      </li>}
      
      {user && user.modules && user.modules['Flows'] && <li className="nav__item">
        <Link to={'/triggers'} className="nav__link nav__link--reports">Процессы</Link>
      </li>}

      {user && user.modules && user.modules['Settings'] && <li className="nav__item">
        <Link to={'/settings'} className="nav__link nav__link--settings">Настройки</Link>
      </li>}
      <li className="nav__item nav__item--last">
        <Link to={'/logout'} className="nav__link nav__link--exit"></Link>
      </li>
    </ul>
  </aside>;
}
